module.exports = "/_next/static/images/GOER-Incentives-Charles-b93486e7afea58bdc8f909da09ec2e32.svg";